export const communityPhotos = [
  {
    src: '/assets/gallery/iwd25/IMG_1366.jpg',
    alt: 'Community gathering at IWD Innovation Summit 2025',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0558.jpg',
    alt: 'Attendees networking at Michigan DevFest 2025',
  },
  {
    src: '/assets/gallery/iwd25/IMG_1404.jpg',
    alt: 'Panel discussion at COMPASS event',
  },
  {
    src: '/assets/gallery/iwd26/iwd26-group-01.jpeg',
    alt: 'IWD Innovation Summit 2026 group photo',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0600.jpg',
    alt: 'Workshop participants at DevFest',
  },
]

export const innovationSummitPhotos = [
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0576.jpg',
    alt: 'Keynote session at Michigan DevFest 2025',
  },
  {
    src: '/assets/gallery/iwd25/IMG_1367.jpg',
    alt: 'Speaker presenting at Innovation Summit',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0579.jpg',
    alt: 'Tech talk at DevFest conference',
  },
  {
    src: '/assets/gallery/iwd25/IMG_1413.jpg',
    alt: 'Audience engaged during keynote',
  },
]

export const hackathonPhotos = [
  {
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0520.jpg',
    alt: 'Teams collaborating at AI Hackathon',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0522.jpg',
    alt: 'Developers coding at hackathon station',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0524.jpg',
    alt: 'Hackathon team presenting project',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/Ai hackathon/IMG_0526.jpg',
    alt: 'AI hackathon participants working together',
  },
]

export const careerMentorshipPhotos = [
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0534.jpg',
    alt: 'One-on-one mentorship session',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0535.jpg',
    alt: 'Career workshop participants',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0539.jpg',
    alt: 'Professional networking at COMPASS event',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0544.jpg',
    alt: 'Resume review workshop',
  },
]

export const prideSummitPhotos = [
  {
    src: '/assets/gallery/iwd26/iwd26-group-02.jpeg',
    alt: 'COMPASS community celebration',
  },
  {
    src: '/assets/gallery/iwd26/iwd26-group-03.jpeg',
    alt: 'Inclusive tech summit speakers',
  },
  {
    src: '/assets/gallery/iwd26/iwd26-group-04.jpeg',
    alt: 'Tech professionals networking',
  },
]

export const devCollaborationPhotos = [
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0588.jpg',
    alt: 'Developers collaborating on project',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0591.jpg',
    alt: 'Pair programming session',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0592.jpg',
    alt: 'Team working on code together',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0593.jpg',
    alt: 'Dev team collaboration',
  },
]

export const womenInTechPhotos = [
  {
    src: '/assets/gallery/iwd25/IMG_1422.jpg',
    alt: 'Women tech leaders at IWD Summit',
  },
  {
    src: '/assets/gallery/iwd25/IMG_1424.jpg',
    alt: 'Panel of women in technology',
  },
  {
    src: '/assets/gallery/iwd25/IMG_1437.jpg',
    alt: 'IWD Innovation Summit workshop',
  },
  {
    src: '/assets/gallery/iwd26/iwd26-group-05.jpeg',
    alt: 'Women leading tech innovation',
  },
]

export const devfestPhotos = [
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0548.jpg',
    alt: 'Michigan DevFest 2025 conference hall',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0560.jpg',
    alt: 'DevFest attendees at session',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0575.jpg',
    alt: 'DevFest tech workshop in progress',
  },
  {
    src: '/assets/gallery/devfest25/Student pictures/IMG_0577.jpg',
    alt: 'Crowd at Michigan DevFest keynote',
  },
]
